module.exports = __webpack_public_path__ + "img/blue.2c9db3a8.webp";